import { Skeleton } from '@/design-system/components/ui';

const StyledField = () => {
  return <div className="tw:mb-2" />;
};

const SkeletonForm = () => {
  return (
    <div>
      <Skeleton variant="text" width={200} height={40}>
        <StyledField />
      </Skeleton>
      <Skeleton variant="text" width={150} height={40}>
        <StyledField />
      </Skeleton>
      <Skeleton variant="text" width={120} height={40}>
        <StyledField />
      </Skeleton>
      <Skeleton variant="text" width={180} height={40}>
        <StyledField />
      </Skeleton>
    </div>
  );
};

export default SkeletonForm;
